import React from 'react';
import styled from 'styled-components';
import { H2 } from 'components/common/headers';

const NoUsers = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  text-align: center;
`;

const NoUsersHeader = styled(H2)`
  display: inline-block;
  margin-bottom: 0px;
`;

const UserIcon = styled.div`
  align-self: center;
  display: inline-block;
  height: 56px;
  width: 56px;
  margin-bottom: ${p => p.theme.spacing.insetSmall};
`;

export default function EmptyTeam() {
  return (
    <NoUsers>
      <UserIcon className="profileAvatar-placeholderIcon" />
      <NoUsersHeader>See selected users here</NoUsersHeader>
      <div>Pick agents on the left to form your team</div>
    </NoUsers>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/team_editor/empty_team.jsx